module.exports = __webpack_public_path__ + "static/media/ic_term_insurance_myway.e3770b5e.svg";